import { createStore } from "zustand";
import { createContext } from "react";

export const UserContext = createContext<UserStore | null>(null);

export interface UserProps {
  count: number;
}

export interface UserState extends UserProps {
  inc: () => void;
}

export type UserStore = ReturnType<typeof createUserStore>;

export const createUserStore = (initProps?: Partial<UserProps>) => {
  const DEFAULT_PROPS: UserProps = {
    count: 0,
  };
  return createStore<UserState>()((set) => ({
    ...DEFAULT_PROPS,
    ...initProps,
    inc: () => set((state) => ({ count: ++state.count })),
  }));
};
